import { render, staticRenderFns } from "./v-navbar-notifications.vue?vue&type=template&id=7331277e&scoped=true&"
import script from "./v-navbar-notifications.vue?vue&type=script&lang=js&"
export * from "./v-navbar-notifications.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar-notifications.vue?vue&type=style&index=0&id=7331277e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7331277e",
  null
  
)

export default component.exports